import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useLang } from "@/i18n";

const links = [
  { labelKey: "nav.studio", href: "/le-studio" },
  { labelKey: "nav.prestations", href: "/prestations" },
  { labelKey: "nav.galerie", href: "/galerie" },
  { labelKey: "nav.contact", href: "/contact" },
];

export const Nav = () => {
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();
  const { lang, setLang, t } = useLang();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="main-nav"
      className={`fixed top-0 left-0 right-0 z-50 transition-[background-color,border-color,backdrop-filter] duration-500 border-b ${
        scrolled ? "bg-black/60 backdrop-blur-xl border-white/10" : "bg-transparent border-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-20 flex items-center justify-between">
        <Link to="/" data-testid="nav-logo" className="flex items-center">
          <img src="/logo.png" alt="New Creation Studio" className="h-12 w-auto" />
        </Link>
        <nav className="hidden md:flex items-center gap-10">
          {links.map((l) => (
            <Link
              key={l.labelKey}
              to={l.href}
              data-testid={`nav-link-${l.labelKey.split(".")[1]}`}
              className={`text-sm uppercase tracking-[0.15em] transition-colors duration-300 hover:text-gold ${
                location.pathname === l.href ? "text-gold" : "text-white/70"
              }`}
            >
              {t(l.labelKey)}
            </Link>
          ))}
        </nav>
        <div className="flex items-center gap-5">
          <div className="flex items-center border border-white/20 text-[11px] font-mono tracking-[0.15em]" data-testid="lang-switcher">
            <button onClick={() => setLang("fr")} data-testid="lang-fr"
              className={`px-3 py-2 transition-colors duration-300 ${lang === "fr" ? "bg-gold text-black" : "text-white/60 hover:text-gold"}`}>
              FR
            </button>
            <button onClick={() => setLang("en")} data-testid="lang-en"
              className={`px-3 py-2 transition-colors duration-300 ${lang === "en" ? "bg-gold text-black" : "text-white/60 hover:text-gold"}`}>
              EN
            </button>
          </div>
          <Link to="/contact" data-testid="nav-cta-reserver"
            className="hidden sm:block border border-gold text-gold px-6 py-2.5 text-sm uppercase tracking-[0.15em] transition-colors duration-300 hover:bg-gold hover:text-black"
          >
            {t("nav.reserve")}
          </Link>
        </div>
      </div>
    </header>
  );
};
